// Mariscos Popeye 1985 — Menú
// NOTA: Edite este archivo para actualizar precios o platillos.
// Los precios están expresados en pesos mexicanos (MXN).

export const RESTAURANT_INFO = {
  name: "Mariscos Popeye 1985",
  tagline: "Directo del mar a su paladar.",
  founded: 1985,
  address: "Av. Hidalgo 1313, Col. Ferrocarrilera, Chihuahua, Chih.",
  phone: "6148079239",
  phoneDisplay: "614 807 9239",
  whatsapp: "5216142501192",
  whatsappDisplay: "614 250 1192",
  instagram: "mariscospopeye1985",
  instagramUrl: "https://instagram.com/mariscospopeye1985",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Av.+Hidalgo+1313+Ferrocarrilera+Chihuahua",
  mapsEmbed:
    "https://www.google.com/maps?q=Av.+Hidalgo+1313,+Ferrocarrilera,+Chihuahua&output=embed",
  hours: {
    label: "Lunes a Domingo · 11:00 a.m. – 7:00 p.m.",
    openHour: 11,
    closeHour: 19, // 7:00 p.m.
  },
};

// Imágenes reales de Mariscos Popeye 1985
export const IMAGES = {
  hero: "https://customer-assets.emergentagent.com/job_popeye-1/artifacts/zt0sjrdt_Hero.jpg",
  aerial:
    "https://customer-assets.emergentagent.com/job_popeye-1/artifacts/8sdrrabg_Platillos%28Destacados-galeria%29.jpg",
  ceviches:
    "https://customer-assets.emergentagent.com/job_popeye-1/artifacts/qwhhgd7u_Ceviches.jpg",
  aguachile:
    "https://customer-assets.emergentagent.com/job_popeye-1/artifacts/qadga22x_Aguachile.jpg",
  filete:
    "https://customer-assets.emergentagent.com/job_popeye-1/artifacts/3hx8giin_FileteEmpanizado.jpg",
  // Nuevas
  camaronesMexicana:
    "https://customer-assets.emergentagent.com/job_popeye-1/artifacts/9hujttyk_CamaronesALaMexicana.jpg",
  camaronesDiabla:
    "https://customer-assets.emergentagent.com/job_popeye-1/artifacts/32f1d0a7_CamaronesALaDiabla.jpg",
  paraLlevar:
    "https://customer-assets.emergentagent.com/job_popeye-1/artifacts/5n3lzfmp_ParaLlevar.jpg",
  hamburguesas:
    "https://customer-assets.emergentagent.com/job_popeye-1/artifacts/pbk3l1qm_Hamburguesas.jpg",
  cocteles:
    "https://customer-assets.emergentagent.com/job_popeye-1/artifacts/nv442zz1_Cocteles.jpg",
  local:
    "https://customer-assets.emergentagent.com/job_popeye-1/artifacts/csz05lna_NuestroLocal.jpg",
};

export const FEATURED_DISHES = [
  // Big hero tile — molcajete close-up (mostly food)
  {
    name: "Aguachile",
    description: "Camarón, pulpo y mariscos en salsa de la casa.",
    image: IMAGES.hero,
    position: "center 95%",
    zoom: 1.15,
  },
  // Wide top — aerial food shot
  {
    name: "Filete Empanizado",
    description: "Pan artesanal, camarón al gusto y aderezo de la casa.",
    image: IMAGES.aerial,
    position: "right center",
    zoom: 1.05,
  },
  // Small
  {
    name: "Cócteles",
    description: "Pescado y camarón curado en limón con verduras frescas.",
    image: IMAGES.ceviches,
    position: "85% 100%",
    zoom: 1.35,
  },
  // Small
  {
    name: "Aguachiles",
    description: "Camarón fresco bañado en chile, limón y pepino.",
    image: IMAGES.aguachile,
    position: "center 100%",
    zoom: 1.3,
  },
  // Wide bottom — pure food shot
  {
    name: "Mojarra Frita",
    description: "Filete de pescado dorado y crujiente, recién hecho.",
    image: IMAGES.filete,
    position: "center",
    zoom: 1.05,
  },
];

// Galería visual con todas las fotos reales del restaurante.
// Orden con foco en variedad: comida, platillos diferentes, ambiente.
export const GALLERY = [
  // Cycle 1
  {
    src: IMAGES.aerial,
    alt: "Variedad de platillos: ceviche, filete empanizado, cóctel y hamburguesa de camarón",
    tag: "La mesa completa",
    position: "center",
    zoom: 1.05,
  },
  {
    src: IMAGES.camaronesDiabla,
    alt: "Filete empanizado bañado en camarones a la diabla",
    tag: "Filete a la diabla",
    position: "center",
    zoom: 1.08,
  },
  {
    src: IMAGES.hero,
    alt: "Molcajete Popeye Caliente con mariscos",
    tag: "Molcajete Popeye Caliente",
    position: "center 95%",
    zoom: 1.15,
  },
  {
    src: IMAGES.hamburguesas,
    alt: "Burgers de camarón, res y pescado con papas a la francesa",
    tag: "Burgers de camarón, res y pescado",
    position: "center",
    zoom: 1.05,
  },
  {
    src: IMAGES.camaronesMexicana,
    alt: "Camarones a la mexicana con arroz, ensalada y papas",
    tag: "Camarones a la Mexicana",
    position: "center 80%",
    zoom: 1.08,
  },
  // Cycle 2
  {
    src: IMAGES.filete,
    alt: "Mojarra frita con arroz, papas y ensalada",
    tag: "Mojarra frita",
    position: "center",
    zoom: 1.05,
  },
  {
    src: IMAGES.paraLlevar,
    alt: "Ceviche para llevar acompañado de Tostitos",
    tag: "Ceviche para llevar",
    position: "center 65%",
    zoom: 1.1,
  },
  {
    src: IMAGES.cocteles,
    alt: "Cocteles de camarón servidos en copa",
    tag: "Cocteles servidos",
    position: "center",
    zoom: 1.1,
  },
  {
    src: IMAGES.aguachile,
    alt: "Molcajete con aguachile de camarón",
    tag: "Aguachiles",
    position: "center 100%",
    zoom: 1.3,
  },
  {
    src: IMAGES.local,
    alt: "Fachada del restaurante Mariscos Popeye 1985 en Chihuahua",
    tag: "Nuestro Local",
    position: "center",
    zoom: 1.05,
  },
];

// Categorías oficiales del menú. Los precios son referenciales —
// modifíquelos aquí cuando lo requiera. Formato: { name, description?, price }
export const MENU_CATEGORIES = [
  {
    id: "cocteles",
    title: "Cócteles",
    note: "Servidos con galletas saladas y salsas de la casa. Disponibles en 5 tamaños.",
    items: [
      {
        name: "Cóctel de Camarón",
        sizes: [
          { label: "Chico", price: "$119" },
          { label: "Grande", price: "$149" },
          { label: "½ Litro", price: "$199" },
          { label: "Jumbo", price: "$249" },
          { label: "Litro", price: "$319" },
        ],
      },
      {
        name: "Cóctel de Pulpo",
        sizes: [
          { label: "Chico", price: "$149" },
          { label: "Grande", price: "$199" },
          { label: "½ Litro", price: "$249" },
          { label: "Jumbo", price: "$299" },
          { label: "Litro", price: "$379" },
        ],
      },
      {
        name: "Cóctel de Ostion",
        sizes: [
          { label: "Chico", price: "$119" },
          { label: "Grande", price: "$149" },
          { label: "½ Litro", price: "$199" },
          { label: "Jumbo", price: "$249" },
          { label: "Litro", price: "$319" },
        ],
      },
      {
        name: "Cóctel de Calamar",
        sizes: [
          { label: "Chico", price: "$119" },
          { label: "Grande", price: "$149" },
          { label: "½ Litro", price: "$199" },
          { label: "Jumbo", price: "$249" },
          { label: "Litro", price: "$319" },
        ],
      },
      {
        name: "Cóctel de Ceviche",
        sizes: [
          { label: "Chico", price: "$99" },
          { label: "Grande", price: "$129" },
          { label: "½ Litro", price: "$169" },
          { label: "Jumbo", price: "$199" },
          { label: "Litro", price: "$269" },
        ],
      },
      {
        name: "Campechana",
        description: "Camarón, pulpo, ostión y calamar.",
        sizes: [
          { label: "Chico", price: "$129" },
          { label: "Grande", price: "$169" },
          { label: "½ Litro", price: "$229" },
          { label: "Jumbo", price: "$269" },
          { label: "Litro", price: "$349" },
        ],
      },
      {
        name: "Combinado",
        description: "Combinación de mariscos a elegir.",
        sizes: [
          { label: "Chico", price: "$129" },
          { label: "Grande", price: "$169" },
          { label: "½ Litro", price: "$229" },
          { label: "Jumbo", price: "$269" },
          { label: "Litro", price: "$349" },
        ],
      },
    ],
  },
  {
    id: "ceviches",
    title: "Ceviches",
    note: "Acompañados de galletas saladas y salsas de la casa. Disponibles en 2 tamaños.",
    items: [
      {
        name: "Ceviche de Pescado",
        sizes: [
          { label: "½ Litro", price: "$160" },
          { label: "Litro", price: "$280" },
        ],
      },
      {
        name: "Ceviche Mixto",
        description: "Pescado y camarón.",
        sizes: [
          { label: "½ Litro", price: "$229" },
          { label: "Litro", price: "$369" },
        ],
      },
      {
        name: "Ceviche Campechano Especial",
        description: "Con todo.",
        sizes: [
          { label: "½ Litro", price: "$269" },
          { label: "Litro", price: "$399" },
        ],
      },
    ],
  },
  {
    id: "tostadas",
    title: "Tostadas",
    items: [
      { name: "Tostada de Ceviche de Pescado", price: "$59" },
      {
        name: "Tostada de Ceviche de Pescado",
        description: "Con camarón, ostión o pulpo.",
        price: "$99",
      },
      { name: "Tostada Especial con Todo", price: "$119" },
      {
        name: "Tostada de Aguacate y Camarón",
        description: "Apio, cebolla, cilantro y pepino.",
        price: "$99",
      },
    ],
  },
  {
    id: "tosticeviches",
    title: "Tosticeviches",
    items: [
      { name: "Tosticeviche de Pescado", price: "$189" },
      {
        name: "Tosticeviche Mixto",
        description: "Pescado y camarón.",
        price: "$249",
      },
      {
        name: "Tosticeviche Popeye Especial con Todo",
        description: "Pescado, camarón y pulpo.",
        price: "$259",
      },
    ],
  },
  {
    id: "aguachiles",
    title: "Aguachiles",
    note: "Camarón bañado en salsa de la casa. Disponibles en 3 tamaños.",
    items: [
      {
        name: "Aguachile Cocido",
        sizes: [
          { label: "Mediano", price: "$219" },
          { label: "Grande", price: "$269" },
          { label: "Litro", price: "$329" },
        ],
      },
      {
        name: "Aguachile Crudo o Mixto",
        sizes: [
          { label: "Mediano", price: "$229" },
          { label: "Grande", price: "$269" },
          { label: "Litro", price: "$349" },
        ],
      },
      {
        name: "Aguachile Campechano",
        sizes: [
          { label: "Mediano", price: "$239" },
          { label: "Grande", price: "$279" },
          { label: "Litro", price: "$349" },
        ],
      },
    ],
  },
  {
    id: "ostiones",
    title: "Ostiones",
    items: [
      {
        name: "Ostiones en Concha",
        sizes: [
          { label: "Pieza", price: "$30" },
          { label: "½ Docena", price: "$150" },
          { label: "Docena", price: "$280" },
        ],
      },
      {
        name: "Shots",
        sizes: [
          { label: "Ostion", price: "$25" },
          { label: "Camarón", price: "$25" },
          { label: "Pulpo", price: "$25" },
        ],
      },
      { name: "Mixto", price: "$35" },
    ],
  },
  {
    id: "caldos",
    title: "Caldos",
    note: "Preparados al momento. Disponible en tamaño Mediano, Grande y Para Llevar (Litro).",
    items: [
      {
        name: "Consomé",
        sizes: [
          { label: "Mediano", price: "$49" },
          { label: "Grande", price: "$69" },
          { label: "P/Llevar Litro", price: "$89" },
        ],
      },
      {
        name: "Caldo de Oso",
        sizes: [
          { label: "Mediano", price: "$119" },
          { label: "Grande", price: "$149" },
          { label: "P/Llevar Litro", price: "$199" },
        ],
      },
      {
        name: "Caldo de Camarón",
        sizes: [
          { label: "Mediano", price: "$209" },
          { label: "Grande", price: "$259" },
          { label: "P/Llevar Litro", price: "$349" },
        ],
      },
      {
        name: "Caldo de Oso y Camarón",
        sizes: [
          { label: "Mediano", price: "$199" },
          { label: "Grande", price: "$249" },
          { label: "P/Llevar Litro", price: "$299" },
        ],
      },
      {
        name: "Caldo de Mariscos",
        sizes: [
          { label: "Mediano", price: "$219" },
          { label: "Grande", price: "$269" },
          { label: "P/Llevar Litro", price: "$359" },
        ],
      },
      {
        name: "Caldo de Filete",
        sizes: [
          { label: "Mediano", price: "$179" },
          { label: "Grande", price: "$229" },
          { label: "P/Llevar Litro", price: "$249" },
        ],
      },
      {
        name: "Caldo Especial Filete y Camarón",
        sizes: [
          { label: "Mediano", price: "$219" },
          { label: "Grande", price: "$269" },
          { label: "P/Llevar Litro", price: "$319" },
        ],
      },
    ],
  },
  {
    id: "ensaladas",
    title: "Ensaladas",
    note: "Preparadas al momento con ingredientes frescos.",
    items: [
      { name: "Ensalada de Atún", price: "$189" },
      { name: "Ensalada de Camarón", price: "$229" },
      { name: "Ensalada de Mariscos", price: "$249" },
      { name: "Ensalada Combinada", price: "$249" },
    ],
  },
  {
    id: "especialidades",
    title: "Especialidades",
    note: "Disponibles en tamaño Mediano y Grande.",
    items: [
      {
        name: "Torre de Mariscos",
        sizes: [
          { label: "Mediano", price: "$249" },
          { label: "Grande", price: "$349" },
        ],
      },
      {
        name: "Empapelado Popeye",
        sizes: [{ label: "Grande", price: "$299" }],
      },
      {
        name: "Platillo Popeye",
        description: "Ceviche y camarón.",
        sizes: [
          { label: "Mediano", price: "$249" },
          { label: "Grande", price: "$349" },
        ],
      },
      {
        name: "Mar y Tierra",
        sizes: [{ label: "Grande", price: "$289" }],
      },
      {
        name: "Camarón para Picar",
        sizes: [
          { label: "Mediano", price: "$219" },
          { label: "Grande", price: "$269" },
        ],
      },
      {
        name: "Tacos Popeye",
        description: "De camarón o mariscos.",
        sizes: [{ label: "Grande", price: "$269" }],
      },
      {
        name: "Arroz Especial Popeye",
        description: "Con camarón, pulpo y filete al gusto.",
        sizes: [{ label: "Grande", price: "$249" }],
      },
      {
        name: "Mariscada Popeye Fría",
        sizes: [
          { label: "Mediano", price: "$249" },
          { label: "Grande", price: "$299" },
        ],
      },
      {
        name: "Molcajete Popeye Caliente",
        sizes: [
          { label: "Mediano", price: "$249" },
          { label: "Grande", price: "$279" },
        ],
      },
      {
        name: "Camarones Ahogados",
        sizes: [
          { label: "Mediano", price: "$219" },
          { label: "Grande", price: "$269" },
        ],
      },
      {
        name: "Pescado Frito",
        description: "Con arroz, ensalada y consomé.",
        price: "Consultar",
      },
      {
        name: "Quesadilla de Camarón",
        description: "Harina o maíz.",
        sizes: [{ label: "Grande", price: "$199" }],
      },
    ],
  },
  {
    id: "camarones",
    title: "Camarones al Gusto",
    note: "Disponibles en tamaño Mediano y Grande.",
    items: [
      {
        name: "Empanizados",
        sizes: [
          { label: "Mediano", price: "$229" },
          { label: "Grande", price: "$269" },
        ],
      },
      {
        name: "Al Mojo de Ajo",
        sizes: [
          { label: "Mediano", price: "$229" },
          { label: "Grande", price: "$269" },
        ],
      },
      {
        name: "A la Diabla",
        sizes: [
          { label: "Mediano", price: "$229" },
          { label: "Grande", price: "$269" },
        ],
      },
      {
        name: "Rancheros",
        sizes: [
          { label: "Mediano", price: "$229" },
          { label: "Grande", price: "$269" },
        ],
      },
      {
        name: "A la Mexicana con Queso",
        sizes: [
          { label: "Mediano", price: "$229" },
          { label: "Grande", price: "$269" },
        ],
      },
      {
        name: "A la Mantequilla",
        sizes: [
          { label: "Mediano", price: "$229" },
          { label: "Grande", price: "$269" },
        ],
      },
      {
        name: "Fiesta",
        description: "Con tocino y queso.",
        sizes: [{ label: "Grande", price: "$299" }],
      },
      {
        name: "A la Diabla Crema Chipotle",
        sizes: [
          { label: "Mediano", price: "$239" },
          { label: "Grande", price: "$289" },
        ],
      },
    ],
  },
  {
    id: "filetes",
    title: "Filete al Gusto",
    note: "Disponible en tamaño Mediano y Grande.",
    items: [
      {
        name: "Empanizado",
        sizes: [
          { label: "Mediano", price: "$199" },
          { label: "Grande", price: "$249" },
        ],
      },
      {
        name: "Al Mojo de Ajo",
        sizes: [
          { label: "Mediano", price: "$199" },
          { label: "Grande", price: "$249" },
        ],
      },
      {
        name: "A la Mantequilla",
        sizes: [
          { label: "Mediano", price: "$199" },
          { label: "Grande", price: "$249" },
        ],
      },
      {
        name: "A la Mexicana",
        sizes: [
          { label: "Mediano", price: "$199" },
          { label: "Grande", price: "$249" },
        ],
      },
      {
        name: "A la Diabla Chipotle",
        sizes: [
          { label: "Mediano", price: "$199" },
          { label: "Grande", price: "$249" },
        ],
      },
      {
        name: "Ranchero",
        sizes: [
          { label: "Mediano", price: "$199" },
          { label: "Grande", price: "$249" },
        ],
      },
      {
        name: "A la Diabla Crema Chipotle",
        sizes: [
          { label: "Mediano", price: "$219" },
          { label: "Grande", price: "$269" },
        ],
      },
      {
        name: "Filete Empanizado",
        description: "Con camarón al gusto.",
        sizes: [
          { label: "Mediano", price: "$239" },
          { label: "Grande", price: "$299" },
        ],
      },
    ],
  },
  {
    id: "hamburguesas",
    title: "Hamburguesas",
    footerNote: "Con Papas y Refresco +$69",
    items: [
      { name: "Filete Empanizado o Carne de Res", price: "$99" },
      { name: "Camarón Empanizado", price: "$149" },
      { name: "Camarón a la Mexicana", price: "$149" },
      { name: "Filete Empanizado y Carne de Res", price: "$149" },
      {
        name: "Filete Empanizado con Camarones a la Mexicana",
        price: "$169",
      },
      {
        name: "Carne de Res con Camarones a la Mexicana",
        price: "$169",
      },
      { name: "Orden de Papas a la Francesa", price: "$89" },
    ],
  },
  {
    id: "combos",
    title: "Combos",
    layout: "combos",
    note: "Incluyen los productos indicados. Las opciones marcadas con \"ó\" son a elegir.",
    items: [
      {
        name: "Combo 1",
        details: ["1 Cóctel Grande", "2 Tostadas", "1 Soda"],
        price: "$269",
      },
      {
        name: "Combo 2",
        details: [
          [
            "1 Super Popeye",
            "1 Sopa de Mariscos Grande",
            "1 Caldo de Camarón Grande",
          ],
          "1 Tostada de Ceviche",
          "1 Soda",
        ],
        price: "$319",
      },
      {
        name: "Combo 3",
        details: [
          "1 Caldo de Oso",
          "1 Tostada de Ceviche",
          "1 Cóctel Chico",
          "1 Soda",
        ],
        price: "$289",
      },
      {
        name: "Combo 4",
        details: [
          ["1 Campechana ½ Litro", "1 Sopa de Mariscos"],
          "1 Tostada de Ceviche",
          "1 Soda",
        ],
        price: "$289",
      },
      {
        name: "Combo 5",
        details: ["1 Caldo de Oso", "2 Tostadas de Ceviche", "1 Soda"],
        price: "$249",
      },
      {
        name: "Combo 6",
        details: ["1 Caldo de Oso", "1 Filete Empanizado Grande", "1 Soda"],
        price: "$369",
      },
      {
        name: "Combo 7",
        details: ["1 Cóctel Chico", "1 Tostada", "1 Soda"],
        price: "$189",
      },
      {
        name: "Combo 8",
        details: ["½ Litro Cóctel", "½ Litro de Ceviche", "2 Sodas"],
        price: "$399",
      },
      {
        name: "Combo 9",
        details: ["1 Litro Cóctel", "1 Litro Ceviche", "1 Soda 2 Litros"],
        price: "$599",
      },
      {
        name: "Combo 10",
        details: [
          "1 Sopa de Mariscos Mediana",
          "1 Cóctel Chico",
          "1 Soda",
        ],
        price: "$339",
      },
      {
        name: "Combo 11",
        details: [
          "1 Caldo de Oso",
          "1 Cóctel Chico de Ceviche",
          "1 Soda",
        ],
        price: "$219",
      },
      {
        name: "Combo 12",
        details: [
          "1 Caldo de Camarón Mediano",
          "1 Tostada de Ceviche",
          "1 Soda",
        ],
        price: "$269",
      },
      {
        name: "Combo 13",
        details: ["1 Caldo de Oso", "1 Filete Mediano Empanizado", "1 Soda"],
        price: "$299",
      },
      {
        name: "Combo Filete",
        featured: true,
        details: [
          "1 Filete Mediano Empanizado",
          "Arroz",
          "Ensalada",
          "Consomé",
          "1 Soda",
        ],
        price: "$199",
      },
      {
        name: "Combo Burger",
        featured: true,
        details: [
          "Hamburguesa de Filete Empanizado o Carne de Res",
          "Papas",
          "Soda",
        ],
        price: "$149",
      },
    ],
  },
  {
    id: "bebidas",
    title: "Bebidas",
    items: [
      { name: "Soda 355 ml", description: "Vidrio.", price: "$39" },
      { name: "Soda de Lata", price: "$39" },
      { name: "Soda 600 ml", price: "$49" },
      {
        name: "Limonada Natural",
        sizes: [
          { label: "Chabela", price: "$49" },
          { label: "Litro", price: "$79" },
        ],
      },
      {
        name: "Limonada Mineral",
        sizes: [
          { label: "Chabela", price: "$69" },
          { label: "Litro", price: "$99" },
        ],
      },
      {
        name: "Horchata",
        sizes: [
          { label: "Chabela", price: "$49" },
          { label: "Litro", price: "$79" },
        ],
      },
      { name: "Fuze Tea Lata", price: "$39" },
      { name: "Fuze Tea 600 ml", price: "$49" },
      { name: "Clamato Preparado", description: "Litro.", price: "$99" },
      { name: "Chabela de Clamato", price: "$49" },
      { name: "Botella de Agua", price: "$29" },
      { name: "Jarra de Limonada Natural", description: "2 Litros.", price: "$119" },
      { name: "Jarra de Limonada Mineral", description: "2 Litros.", price: "$159" },
      { name: "Jarra de Horchata", description: "2 Litros.", price: "$119" },
    ],
  },
  {
    id: "extras",
    title: "Extras",
    items: [
      { name: "Totopos", price: "$30" },
      { name: "Aguacate", price: "$10" },
      { name: "Guacamole", price: "$69" },
      { name: "Rebanada de Pay", price: "$59" },
    ],
  },
];
